import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import TradingSignalsWidget from './TradingSignalsWidget';
import SignalDetailPage from './SignalDetail';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TradingSignalsWidget />} />
        <Route path="/signal/:id" element={<SignalDetailPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);